<div class="modal-header">
  <h3 class="modal-title">{{alertDialog.HeadingText}}</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="overflow-x mt-3" style="width: 100%;">
    {{alertDialog.BodyText}}
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm btn-default" *ngIf="alertDialog.cancelButtonText == ''" [mat-dialog-close]="">Cancel</button>
  <button class="btn btn-sm btn-default" *ngIf="alertDialog.cancelButtonText != ''" [mat-dialog-close]="">{{alertDialog.cancelButtonText}}</button>
  <button class="btn btn-sm bg-g-red" *ngIf="alertDialog.IsAction" [mat-dialog-close]="alertDialog.HeadingText"
    cdkFocusInitial>{{alertDialog.ActionButtonText}}</button>
</div>

